// extracted by mini-css-extract-plugin
export var pillWrapper = "_q6-0";
export var showOverflow = "_q6-1";